import {
  Box,
  Button,
  Grid,
  Stack,
  IconButton,
  TextField,
  Typography,
  Divider,
  FormGroup,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import RImage from "../../assets/r.png";
import { useEffect, useState } from "react";
import LiraImage from "../../assets/lira.png";
import TejaratImage from "../../assets/tejarat.png";
import { Container } from "@mui/system";
import CurrencySelector from "../../components/atomic/currencyselector";
import ChangeIcon from "../../assets/change_sell_buy.png";
import ChartPicture from "../../assets/chart_easy_sell.png";
import ExpandMoreOutlinedIcon from "@mui/icons-material/ExpandMoreOutlined";
import KeyboardArrowLeftOutlinedIcon from "@mui/icons-material/KeyboardArrowLeftOutlined";
import TextSwitchEasySellBuy from "../../components/atomic/textswitcheasysellbuy/TextSwitchEasySellBuy";
import "./EasySellBuy.css";
import GooglePlayImage from "../../assets/google_play_icon_buy_sell.png";
import AppStoreImage from "../../assets/app_store_icon_buy_sell.png";
import { Link } from "react-router-dom";
import AppliacationImage from "../../assets/app_pic_2.png";
import BuyFiatIcon from "../../assets/buyfiat.png";
import BankTransferIcon from "../../assets/banktransfer.png";
import TradeIcon from "../../assets/trade-buybtc.png";
import EthIcon from "../../assets/eth.png";
import SolanaIcon from "../../assets/solana.png";
import DogeIcon from "../../assets/doge.png";
import RedIcon from "../../assets/red.png";
import BitcoinIcon3 from "../../assets/bitcoin3.png";
import axios from "axios";
import TradingViewChart from "../../components/compound/TradingView/TradingView";
import CurrencyList from "../../components/compound/currencylist/currencylist";
import FiatForm from "../../components/compound/calculator/calculator";

interface FormInterface {
  value: number;
  index: number;
}

function DepositForm() {
  const { t } = useTranslation();
  const [value, setValue] = useState(0);
  const items = [
    {
      value: "IRT",
      country: "IRAN",
      label: "ریال",
      balance: "10,439,000",
      icon: RImage,
    },
    {
      value: "Lire",
      country: "TRUKISH",
      label: "لیر",
      balance: "400",
      icon: LiraImage,
    },
  ];
  const items2 = [
    {
      value: "Lire",
      country: "TRUKISH",
      label: "لیر",
      balance: "400",
      icon: LiraImage,
    },
    {
      value: "IRT",
      country: "IRAN",
      label: "ریال",
      balance: "10,439,000",
      icon: RImage,
    },
  ];
  const cards = [
    {
      value: "3s4df",
      label: "6104-3371-1012-4341",
      icon: TejaratImage,
    },
  ];

  function CrypoForm(props: FormInterface) {
    const [show, setShow] = useState(false);
    return (
      <Box hidden={props.value !== props.index} mt={4}>
        <Box>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={0.5}
            alignItems={{ xs: "start", sm: "center" }}
            justifyContent={"space-between"}
            my={1}
          >
            <Typography variant="subtitle2" component="p" color="text.title">
              {t("i_sell")}
            </Typography>
            <Stack
              direction={{ xs: "column", sm: "row" }}
              spacing={1}
              alignItems={{ xs: "start", sm: "center" }}
            >
              <Stack direction={"row"} spacing={0.25} alignItems={"center"}>
                <Typography
                  variant="subtitle2"
                  component="p"
                  color="text.title"
                >
                  {t("my_balance")}
                </Typography>
                <Typography variant="caption" component="p" color="text.title">
                  {t("num_toman")}
                </Typography>
              </Stack>
              <Typography variant="subtitle2" component="p" color="#ff3dff">
                {t("all_balance")}
              </Typography>
            </Stack>
          </Stack>
        </Box>
        <Box>
          <TextFieldpay />
        </Box>
        <Box>
          <Box sx={{ display: "flex", justifyContent: "center", pt: 2, pb: 0 }}>
            <IconButton sx={{ "&:hover": { backgroundColor: "#222631" } }}>
              <img
                src={ChangeIcon}
                alt="change icon"
                width="100%"
                style={{ borderRadius: "50%" }}
              />
            </IconButton>
          </Box>
        </Box>
        <Box>
          <Typography
            variant="subtitle2"
            component="p"
            color="text.title"
            sx={{ mb: 1.5 }}
          >
            {t("i_receive")}
          </Typography>
          <TextFieldrecive />
        </Box>
        <Box>
          <Stack
            direction={"row"}
            spacing={0.5}
            alignItems={"center"}
            justifyContent={"space-between"}
            my={1}
          >
            <Typography variant="subtitle2" component="p" color="text.title">
              {t("bitcoin_price_now")}
            </Typography>
            <Typography variant="subtitle2" component="p" color="text.title">
              {t("price_btc")}
            </Typography>
          </Stack>
        </Box>
        <Box>
          <Stack
            direction={"row"}
            spacing={0.5}
            alignItems={"center"}
            justifyContent={"space-between"}
            my={1}
          >
            <Typography variant="subtitle2" component="p" color="text.title">
              {t("wage")}
            </Typography>
            <Typography variant="subtitle2" component="p" color="text.title">
              {t("price_wage")}
            </Typography>
          </Stack>
        </Box>
        <Box>
          <Stack direction={"column"} spacing={0.5} my={1}>
            <Button
              sx={{
                "&:hover": { backgroundColor: "#222631" },
                width: "fit-content",
              }}
              className="btn_hide-show-off-code"
            >
              <Stack
                direction={"row"}
                onClick={() => setShow(!show)}
                spacing={0.1}
                alignItems={"center"}
              >
                {show ? (
                  <ExpandMoreOutlinedIcon sx={{ color: "#0082FD" }} />
                ) : (
                  <KeyboardArrowLeftOutlinedIcon sx={{ color: "#0082FD" }} />
                )}
                <Typography variant="subtitle2" component="p" color="#0082FD">
                  {t("have_off_code")}
                </Typography>
              </Stack>
            </Button>
            {show ? (
              <FormGroup>
                <TextField
                  fullWidth
                  placeholder={`${t("enter_off_code")}`}
                  InputProps={{
                    style: {
                      padding: 0,
                      borderRadius: "50px",
                    },
                  }}
                />
              </FormGroup>
            ) : null}
          </Stack>
        </Box>
        <Box>
          <Button
            size={"large"}
            fullWidth
            variant={"contained"}
            sx={{
              bgcolor: "#EA3943",
              color: "text.title",
              "&:hover": { bgcolor: "#EA3943" },
            }}
          >
            {t("sell_bitcoin")}
          </Button>
        </Box>
      </Box>
    );
  }
  function TextFieldpay() {
    return (
      <FormGroup
        sx={{
          border: "1px solid rgba(255, 255, 255, 0.23)",
          borderRadius: "50px",
          display: "flex",
          flexWrap: "nowrap",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <TextField
          fullWidth
          className="search-input-faq"
          id="pay"
          placeholder={`${t("enter_price")}`}
          InputProps={{
            style: {
              padding: 0,
              borderRadius: "50px",
              border: "none",
            },
          }}
        />
        <CurrencySelector items={items} />
      </FormGroup>
    );
  }
  function TextFieldrecive() {
    return (
      <FormGroup
        sx={{
          border: "1px solid rgba(255, 255, 255, 0.23)",
          borderRadius: "50px",
          display: "flex",
          alignItems: "center",
          flexWrap: "nowrap",
          flexDirection: "row",
        }}
      >
        <TextField
          id="buy"
          fullWidth
          className="search-input-faq"
          placeholder={`${t("enter_count")}`}
          InputProps={{
            style: {
              padding: 0,
              borderRadius: "50px",
            },
          }}
        />
        <CurrencySelector items={items2} />
      </FormGroup>
    );
  }
  return (
    <Box sx={{ p: 2 }}>
      <Grid container spacing={{ xs: 0, sm: 2 }}>
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          sx={{
            bgcolor: "background.darkBlack",
            py: 3,
            px: 2,
            borderRadius: "10px",
            mt: 2,
            height: "fit-content",
          }}
        >
          <FiatForm />
        </Grid>
        <Grid
          item
          xs={12}
          sm={12}
          md={8}
          mt={{ xs: 2, sm: 0 }}
          pl={{ xs: 0, md: 2 }}
        >
          <Box sx={{ borderRadius: "12px" }}>
            <TradingViewChart />
          </Box>
          <Stack
            sx={{
              bgcolor: "background.darkBlack",
              pt: 2,
              px: 1.5,
              borderRadius: "10px",
              my: 2.5,
            }}
          >
            <Typography
              variant="h6"
              component="p"
              color="text.primary"
              sx={{ textAlign: "start" }}
            >
              ارز دیجیتال چیست؟
            </Typography>
            <Typography
              variant="subtitle1"
              component="p"
              color="text.secondary"
              sx={{ textAlign: "left", lineHeight: "20px", my: 2 }}
            >
              ارز دیجیتال (Cryptocurrency) یک نوع ارز مبتنی بر فناوری دیجیتال
              است که برای تبادل ارزش طراحی شده و معمولاً بر پایه فناوری بلاکچین
              (Blockchain) عمل می‌کند. ارزهای دیجیتال از رمزنگاری برای امنیت و
              تأیید تراکنش‌ها استفاده می‌کنند و توسط هیچ نهاد مرکزی مانند دولت
              یا بانک‌ها کنترل نمی‌شوند. ویژگی‌های اصلی ارز دیجیتال: دیجیتال
              بودن این ارزها به‌صورت فیزیکی وجود ندارند و تمام تبادلات آن‌ها
              به‌صورت آنلاین انجام می‌شود. غیرمتمرکز بودن اکثر ارزهای دیجیتال،
              مانند بیت‌کوین و اتریوم، غیرمتمرکز هستند، یعنی توسط یک نهاد مرکزی
              کنترل نمی‌شوند و بر روی شبکه‌ای از کامپیوترها (نودها) توزیع
              شده‌اند. رمزنگاری از تکنیک‌های رمزنگاری برای تأمین امنیت تراکنش‌ها
              و ایجاد واحدهای جدید ارز استفاده می‌شود. بلاکچین بیشتر ارزهای
              دیجیتال از بلاکچین به‌عنوان دفتر کل توزیع‌شده استفاده می‌کنند. این
              فناوری تمامی تراکنش‌ها را به‌صورت عمومی ثبت می‌کند و امکان دستکاری
              را از بین می‌برد. جهانی بودن ارزهای دیجیتال قابلیت انتقال در سراسر
              جهان را دارند و محدود به مرزهای جغرافیایی نیستند. مزایای ارز
              دیجیتال: تراکنش‌های سریع و کم‌هزینه شفافیت و امنیت بالا کنترل کامل
              کاربران بر دارایی‌هایشان مناسب برای افرادی که به سیستم بانکی
              دسترسی ندارند معروف‌ترین ارزهای دیجیتال: بیت‌کوین (Bitcoin): اولین
              و محبوب‌ترین ارز دیجیتال. اتریوم (Ethereum): با قابلیت اجرای
              قراردادهای هوشمند. بایننس کوین (BNB)، ریپل (XRP)، و کاردانو (ADA)
              از دیگر ارزهای مطرح هستند.{" "}
            </Typography>
            <Divider />
            <Grid container mt={2}>
              <Grid
                item
                xs={12}
                md={6}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                }}
              >
                <Typography
                  variant="h6"
                  component="p"
                  color="text.primary"
                  sx={{ textAlign: "start" }}
                >
                  خرید و فروش سریع ارز دیجیتال با اپلیکیشن{" "}
                </Typography>
                <Typography
                  variant="subtitle1"
                  component="p"
                  color="text.secondary"
                  sx={{ textAlign: "justify", my: 2 }}
                >
                  با استفاده از اپلیکیشن پارسیان بیت در سریع ترین زمان ممکن
                  ارزدیجیتال مورد نیاز خود را تهیه کنید{" "}
                </Typography>
                <Stack direction={"row"} spacing={2} alignItems={"center"}>
                  <Link to="/">
                    <Box>
                      <img src={GooglePlayImage} alt="icon" width="auto" />
                    </Box>
                  </Link>
                  <Link to="/">
                    <Box>
                      <img src={AppStoreImage} alt="icon" width="auto" />
                    </Box>
                  </Link>
                </Stack>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box sx={{ display: "flex" }}>
                  <img src={AppliacationImage} alt="icon" width="auto" />
                </Box>
              </Grid>
            </Grid>
          </Stack>
          <Typography
            variant="h6"
            component="p"
            sx={{ color: "text.title", textAlign: "center", mt: 5, mb: 1 }}
          >
            چرا باید ارز دیجیتال بخریم؟
          </Typography>
          <Grid container spacing={3} sx={{ px: { xs: 0, md: 0 }, py: 2 }}>
            <Grid item sm={6} xs={12} md={4}>
              <Box
                sx={{
                  bgcolor: "background.darkBlack",
                  borderRadius: "10px",
                  p: 1.5,
                }}
              >
                <Stack direction="row" spacing={2} alignItems="center">
                  <Box>
                    <img src={BankTransferIcon} />
                  </Box>
                  <Typography
                    variant="h6"
                    component="span"
                    sx={{
                      color: "text.title",
                      p: 0.25,
                      textAlign: "center",
                      ml: 2,
                    }}
                  >
                    حفظ ارزش سرمایه
                  </Typography>
                </Stack>
                <Typography
                  variant="subtitle2"
                  component="p"
                  sx={{ color: "text.title", mt: 2, textAlign: "justify" }}
                >
                  ارزهای دیجیتال می‌توانند در برابر تورم مقاوم باشند و ارزش
                  دارایی شما را حفظ کنند.
                </Typography>
              </Box>
            </Grid>
            <Grid item sm={6} xs={12} md={4}>
              <Box
                sx={{
                  bgcolor: "background.darkBlack",
                  borderRadius: "10px",
                  p: 1.5,
                }}
              >
                <Stack direction="row" spacing={2} alignItems="center">
                  <Box>
                    <img src={BuyFiatIcon} />
                  </Box>
                  <Typography
                    variant="h6"
                    component="span"
                    sx={{
                      color: "text.title",
                      p: 0.25,
                      textAlign: "center",
                      ml: 2,
                    }}
                  >
                    سرمایه‌گذاری بلندمدت
                  </Typography>
                </Stack>
                <Typography
                  variant="subtitle2"
                  component="p"
                  sx={{ color: "text.title", mt: 2, textAlign: "justify" }}
                >
                  بسیاری از ارزهای دیجیتال در طول زمان رشد قیمتی قابل‌توجهی
                  داشته‌اند.
                </Typography>
              </Box>
            </Grid>
            <Grid item sm={6} xs={12} md={4}>
              <Box
                sx={{
                  bgcolor: "background.darkBlack",
                  borderRadius: "10px",
                  p: 1.5,
                }}
              >
                <Stack direction="row" spacing={2} alignItems="center">
                  <Box>
                    <img src={TradeIcon} />
                  </Box>
                  <Typography
                    variant="h6"
                    component="span"
                    sx={{
                      color: "text.title",
                      p: 0.25,
                      textAlign: "center",
                      ml: 2,
                    }}
                  >
                    امکان مشارکت در فناوری‌های نوین
                  </Typography>
                </Stack>
                <Typography
                  variant="subtitle2"
                  component="p"
                  sx={{ color: "text.title", mt: 2, textAlign: "justify" }}
                >
                  میتوانید از قرارداد های هوشمند و Defi بهره مند شوید
                </Typography>
              </Box>
            </Grid>
          </Grid>
          <Stack
            sx={{
              bgcolor: "background.darkBlack",
              pt: 2,
              px: 1.5,
              borderRadius: "10px",
              my: 2.5,
            }}
          >
            <Typography
              variant="h5"
              component="p"
              sx={{ color: "text.primary", textAlign: "center", mt: 5, mb: 1 }}
            >
              {t("bit_coin_benefits")}
            </Typography>
            <ul className="ul_easy_buy_sell">
              <li>
                <Typography
                  variant="h5"
                  component="p"
                  sx={{ color: "text.primary", textAlign: "start" }}
                >
                  غیرمتمرکز بودن
                </Typography>
                <Typography
                  variant="subtitle1"
                  component="p"
                  sx={{ color: "text.title", textAlign: "start", mt: 1.5 }}
                >
                  بیت‌کوین بدون وابستگی به بانک‌ها یا نهادهای مرکزی کار می‌کند.
                  این ویژگی آن را مقاوم در برابر سانسور و کنترل دولتی می‌کند.
                </Typography>
              </li>
              <li>
                <Typography
                  variant="h5"
                  component="p"
                  sx={{ color: "text.primary", textAlign: "start" }}
                >
                  امنیت بالا
                </Typography>
                <Typography
                  variant="subtitle1"
                  component="p"
                  sx={{ color: "text.title", textAlign: "start", mt: 1.5 }}
                >
                  تراکنش‌های بیت‌کوین بر روی بلاکچین ثبت می‌شوند، که با استفاده
                  از رمزنگاری پیشرفته از تغییر یا دستکاری محافظت می‌شود.
                </Typography>
              </li>
              <li>
                <Typography
                  variant="h5"
                  component="p"
                  sx={{ color: "text.primary", textAlign: "start" }}
                >
                  شفافیت{" "}
                </Typography>
                <Typography
                  variant="subtitle1"
                  component="p"
                  sx={{ color: "text.title", textAlign: "start", mt: 1.5 }}
                >
                  تمامی تراکنش‌های بیت‌کوین در دفتر کل عمومی (بلاکچین) ثبت
                  می‌شوند، و هر کسی می‌تواند آن‌ها را بررسی کند. این شفافیت
                  اعتماد کاربران را افزایش می‌دهد.
                </Typography>
              </li>
              <li>
                <Typography
                  variant="h5"
                  component="p"
                  sx={{ color: "text.primary", textAlign: "start" }}
                >
                  قابلیت انتقال بین‌المللی
                </Typography>
                <Typography
                  variant="subtitle1"
                  component="p"
                  sx={{ color: "text.title", textAlign: "start", mt: 1.5 }}
                >
                  بیت‌کوین امکان ارسال و دریافت پول را در سراسر جهان بدون نیاز
                  به واسطه یا تبدیل ارز فراهم می‌کند، که باعث صرفه‌جویی در هزینه
                  و زمان می‌شود.
                </Typography>
              </li>
            </ul>
          </Stack>
        </Grid>
        <CurrencyList />
      </Grid>
    </Box>
  );
}

export default function EasySellBuy() {
  const { t } = useTranslation();
  return (
    <Box>
      <Box>
        <Container>
          <Grid container sx={{ py: 2, px: 1 }}>
            <Grid item xs={12}>
              <DepositForm />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Box>
  );
}
